export const authConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    GET_USER: 'GET_LOGGEDIN_USER',
    UPDATE_USER : 'USER_DATA_UPDATED',
    AGENT_LIST : 'GET_AGENT_LIST',
    AGENT_LIMIT_LIST : 'AGENT_LIMIT_LIST',
    COMMISSION_LIST : 'COMMISSION_LIST',
    ADD_AGENT_LIMIT : 'ADD_AGENT_LIMIT',
    ADD_AGENT_COMMISSION : 'ADD_AGENT_COMMISSION',
    VERIFY_EMAIL: 'EMAIL_VERIFCATION',
    VERIFY_EMAIL_ADDRESS: 'VERIFY_EMAIL_ADDRESS',
    PAYMENT_METHOD_LIST: 'PAYMENT_METHOD_LIST'

    
}  